import { Navigate } from 'react-router-dom';
import { getUser } from '../utils/auth';

// Lightweight role gate for routes nested inside ProtectedRoute (which
// already validated the token). Redirects to the fleet overview when the
// current user's role is not allowed.
const RequireRoles = ({ roles, children }) => {
  if (!roles.includes(getUser()?.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default RequireRoles;
